/**
 * Owner: Masa Bayu
 * File: color-swatch.ts
 * Date:Time: 2026-09-13 21:16
 * Description: 22C opaque color swatch identity (not CSS/hex values).
 */
const FORBIDDEN = [
    'css',
    'hex',
    'rgb',
    'hsl',
    'oklch',
    'gradient',
    'opacity',
    'shadow',
    'value',
    'className',
    'style',
    'dom',
];
function assertNoForbidden(record, label) {
    for (const key of FORBIDDEN) {
        if (key in record) {
            throw new Error(`${label} must not include render field "${key}"`);
        }
    }
}
function assertId(value, label) {
    if (typeof value !== 'string' || value.trim().length === 0 || /\s/.test(value)) {
        throw new Error(`${label} must be a non-empty id without whitespace`);
    }
}
export function createQXColorSwatch(options) {
    assertNoForbidden({ ...options }, 'Color swatch');
    assertId(options.id, 'Color swatch id');
    if (typeof options.name !== 'string' || options.name.trim().length === 0) {
        throw new Error('Color swatch name must be a non-empty string');
    }
    return Object.freeze({
        id: options.id.trim(),
        name: options.name.trim(),
    });
}
export function isQXColorSwatch(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        return false;
    }
    const record = value;
    return typeof record.id === 'string' && typeof record.name === 'string';
}
//# sourceMappingURL=color-swatch.js.map